export default "__VITE_ASSET__CvBKgxgL__"